import React, { memo } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '../ui/breadcrumb';
import { combineClassNames } from '../../utils/combineClassNames';

type CrumbData = {
  label: string;
  href: string;
};

type BreadcrumbsProps = {
  crumbs: CrumbData[];
};

const BreadcrumbItemWrapper = memo(({ crumb, isLast, showChevron }:
   { crumb: CrumbData; isLast: boolean; showChevron: boolean }) => {
  const match = useRouteMatch(crumb.href);

  if (!match) return null;

  return (
    <>
      <BreadcrumbItem>
        {isLast ? (
          <BreadcrumbPage className="tw-font-semibold">{crumb.label}</BreadcrumbPage>
        ) : (
          <BreadcrumbLink
            asChild className={
            combineClassNames({ 'tw-text-gray-custom-900 tw-font-semibold hover:tw-text-gray-custom-900': !showChevron })
            }
          >
            <Link to={crumb.href}>{crumb.label}</Link>
          </BreadcrumbLink>
        )}
      </BreadcrumbItem>
      {showChevron && <BreadcrumbSeparator />}
    </>
  );
});

const Breadcrumbs = memo(({ crumbs }: BreadcrumbsProps) => {
  if (!crumbs || crumbs.length === 0) return null;

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          return (
            <BreadcrumbItemWrapper
              key={crumb.href}
              crumb={crumb}
              isLast={isLast}
              showChevron={index > 0}
            />
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
});

export default Breadcrumbs;
